export default __webpack_public_path__ + "static/media/icon-return-repaired-phone.8740eb64.svg";